/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateReleaseAndLinkRequest
 */
export interface CreateReleaseAndLinkRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateReleaseAndLinkRequest
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReleaseAndLinkRequest
     */
    source: CreateReleaseAndLinkRequestSourceEnum;
    /**
     * When source is 'other', can provide URL as source_id
     * @type {string}
     * @memberof CreateReleaseAndLinkRequest
     */
    sourceUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReleaseAndLinkRequest
     */
    releaseTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReleaseAndLinkRequest
     */
    dateReleased?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateReleaseAndLinkRequest
     */
    releaseLabels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateReleaseAndLinkRequest
     */
    catNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateReleaseAndLinkRequest
     */
    mediaType?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateReleaseAndLinkRequest
     */
    format?: string;
}


/**
 * @export
 */
export const CreateReleaseAndLinkRequestSourceEnum = {
    Discogs: 'discogs',
    Mb: 'MB',
    Spotify: 'spotify',
    Deezer: 'deezer',
    Ppl: 'ppl',
    Other: 'other'
} as const;
export type CreateReleaseAndLinkRequestSourceEnum = typeof CreateReleaseAndLinkRequestSourceEnum[keyof typeof CreateReleaseAndLinkRequestSourceEnum];


/**
 * Check if a given object implements the CreateReleaseAndLinkRequest interface.
 */
export function instanceOfCreateReleaseAndLinkRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function CreateReleaseAndLinkRequestFromJSON(json: any): CreateReleaseAndLinkRequest {
    return CreateReleaseAndLinkRequestFromJSONTyped(json, false);
}

export function CreateReleaseAndLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateReleaseAndLinkRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'source': json['source'],
        'sourceUrl': !exists(json, 'source_url') ? undefined : json['source_url'],
        'releaseTitle': !exists(json, 'releaseTitle') ? undefined : json['releaseTitle'],
        'dateReleased': !exists(json, 'dateReleased') ? undefined : json['dateReleased'],
        'releaseLabels': !exists(json, 'releaseLabels') ? undefined : json['releaseLabels'],
        'catNumbers': !exists(json, 'catNumbers') ? undefined : json['catNumbers'],
        'mediaType': !exists(json, 'mediaType') ? undefined : json['mediaType'],
        'format': !exists(json, 'format') ? undefined : json['format'],
    };
}

export function CreateReleaseAndLinkRequestToJSON(value?: CreateReleaseAndLinkRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_id': value.sourceId,
        'source': value.source,
        'source_url': value.sourceUrl,
        'releaseTitle': value.releaseTitle,
        'dateReleased': value.dateReleased,
        'releaseLabels': value.releaseLabels,
        'catNumbers': value.catNumbers,
        'mediaType': value.mediaType,
        'format': value.format,
    };
}

